
import { WOW } from "wowjs";

(function ($) {

	$(document).ready(function () {

		const wow = new WOW();

		wow.init();


		let headerScrollTopOffset = 0;

		if ($("body").hasClass("admin-bar") && ($(window).width() > 600)) {
			headerScrollTopOffset = $("html").css("margin-top");
		}

		/**
		 * Header - Search bar functionality
		 */
		let searchButton 	= $( '.js-header-search-btn' );
		let closeButton 	= $( '#close-button' );
		let searchBar 		= $( '#search-container' );

		// Search click
		$.each( searchButton, function () {
			$( this ).on( 'click', function () {
				searchBar.fadeIn().addClass('show');
			});
		});

		// Close click
		closeButton.on( 'click', function () {
			searchBar.fadeOut().removeClass( 'show' );
		});

		/**
		 * Carousel - Set equal heights
		 */
		function alertCarouselEqualHeights() {
			$('#alert-system .carousel').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				// Desktop
				console.log(window.innerWidth);
				$.each( items, function() {
					let caption 		= $(this);
					let captionHeight 	= caption.css('height', 'auto').outerHeight();

					if ( captionHeight > maxHeight ) {
						maxHeight = captionHeight;
					}
				});

				// Apply the max height to all captions
				$.each( items, function() {
					let caption = $(this);
					caption.css('height', maxHeight);

					// Remove .active from all slides
					$( this ).removeClass( 'active' );
				});

				// Add the active class back to the first slide
				$('#alert-system .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}
		alertCarouselEqualHeights();

		/**
		 * Alert Bar - Header spacing accommodation
		 */
		function alertSpacing() {
			if (! $("body").hasClass('alert-hidden')) {
				let alertBarHeight = $('#alert-system').outerHeight();

				$('header').css('padding-top', alertBarHeight);
				$('#content').css('padding-top', alertBarHeight - (alertBarHeight * 0.21929825) + 10);
			}
		}
		alertSpacing();

		$(window).resize(function () {
			alertSpacing();
			alertCarouselEqualHeights();
		});

		$('#alert-system .close').on('click', function() {
			$('#content').css('padding-top', 0);
			$('#search-container').css('margin-top', 0);
		});

		// Set header navbar height

		//calculateNavbarHeight();
		//calculateTopBannerHeight();

		let resizeThrottled = false;

		$(window).on("resize", function(){

			if(!resizeThrottled){

				//calculateNavbarHeight();
				//calculateTopBannerHeight();

				carouselEqualHeights();

				resizeThrottled = true;

				setTimeout(function(){

					resizeThrottled = false;

					//calculateNavbarHeight();
					//calculateTopBannerHeight();

					carouselEqualHeights();

				}, 100);

			}

		});


		// Watch for when header is scrolled to or away from the top of the viewport
		// If header is scrolled to the top of the page, we know it's been stickied based on it having position: sticky
		// Add class when it's sitting at the top of the page, remove it when it's been scrolled away
		$("body > header").observeScrollTopChanges(headerScrollTopOffset).on("scroll-top-change", (evt) => {

			$(evt.target).toggleClass("sticky", evt.detail.scrolledToTop);

		});


		//let desktopMenuBreakpoint = parseInt($(":root").css("--desktop-menu-breakpoint"));

		/**
		 * Desktop menu dropdowns
		 */
		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		// When hovering over a menu item, check for any other menu items at the same level that have a ".focus" class and remove it
		$("#header-navbar-menu-wrapper").find(".menu-item").on("mouseenter", function(){

			$("#header-navbar-menu-wrapper").find(".menu-item.dropdown.focus").removeClass("focus");

		});

		$("#header-navbar-menu-wrapper").find(".menu-item.dropdown")
			.on("mouseenter", function(){

				fadeInMenuDropdown($(this).children(".dropdown-menu"));

			})
			.on("mouseleave", function(){

				fadeOutMenuDropdown($(this).children(".dropdown-menu"));

			})
			.on("focusout", function(){

				let thisDropdown = $(this);

				setTimeout(function(){

					if(thisDropdown.find(".nav-link:focus").length === 0){
						thisDropdown.removeClass("focus");
					}

				}, 100);

			});

		$("#header-navbar-menu-wrapper").find(".menu-item > .nav-link").on("focus", function(){

			$(this).parent().siblings(".menu-item.dropdown").find(".focus").addBack().removeClass("focus");

		});

		$("#header-navbar-menu-wrapper").find(".menu-item.dropdown > .nav-link")
			.on("focus", function(){

				$(this).parent().addClass("focus");

			});


		/**
		 * Mobile menu
		 */

		// Add a class to body to prevent overflow when the menu is open
		$("header .js-mobile-menu-toggle").on("click", function(){
			$("body").toggleClass("no-scroll");
		});

		$("#header-navbar-menu-wrapper.navbar-collapse")
			.on("show.bs.collapse", function(){

				let headerBannerHeight = 0;

				$("body > header").children().each(function(){
					headerBannerHeight += $(this).outerHeight();
				});

				if(!$("body > header").hasClass("sticky")){
					headerBannerHeight += (parseInt($("html").css("margin-top")) - $("html").scrollTop());
				}

				if(($('#alert-system').length > 0) && !$("body").hasClass("alert-hidden")){
					headerBannerHeight += $('#alert-system').outerHeight();
				}

				$(this).css("--mobile-menu-height", ($(window).outerHeight() - headerBannerHeight) + "px");

			});


		// Control sub-menus on mobile
		$( ".menu-item-has-children > a" ).on( "click", function(e) {
			e.preventDefault();
			$(this).parent().toggleClass('open');
		});		


		// Check if the Project Logo is visible, if yes, hide the h1 title
		if ( $('.navbar-brand img').is(":visible") ) {
			$('.navbar-brand h1').addClass('logo-visible');
		}

		/**
		 * Clinic/Centre archive accordions "Expand All" button
		 */
		$('[data-toggle="expand-all"]').on("click", function(){

			let action = $(this).data("action");

			let otherAction = "";

			let targetAccordionWrapper = $($(this).data("target"));

			if(action === "expand"){

				otherAction = "collapse";

				targetAccordionWrapper.find('button[data-toggle="collapse"][aria-expanded="false"]').each(function(){
					$(this).trigger("click");
				});

			}else if(action === "collapse"){

				otherAction = "expand";

				targetAccordionWrapper.find('button[data-toggle="collapse"][aria-expanded="true"]').each(function(){
					$(this).trigger("click");
				});

			}

			$(this)
				.data("action", otherAction)
				.attr("data-action", otherAction)
				.text($(this).data(otherAction + "-text"));

		});


		/**
		 * Video modals
		 */
		$(".video-modal").appendTo("body");


		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top")
			.addClass("fade")
			.on("click", function(){
				$("html, body").animate({
					scrollTop: 0,
				}, 400);
			});

		$(window).scroll(function(){
			if ($(window).scrollTop() > 150){
				$("#back-to-top").addClass("show");
			} else {
				$("#back-to-top").removeClass("show");
			}
		});

		/**
		 * Carousel - Set equal heights
		 */
		let origMinHeight = 0;

		function carouselEqualHeights() {
			$('.carousel-block').each(function () {
				var items 		= $('.carousel-item', this);

				// Set the minimum height of the carousel based on it's height at page load
				if(origMinHeight === 0){
					origMinHeight 	= $(".carousel", this).outerHeight();
				}

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' ).css("height", "auto");
				});

				let maxHeight = origMinHeight;

				// Get the height of the tallest caption and save it
				// Desktop
				if(window.innerWidth >= 1200) {
					$.each( items, function() {
						let caption 		= $('.carousel-caption', this);
						let slideHeight 	= caption.outerHeight();

						// Add carousel item's top and bottom padding to the max height
						slideHeight += ($(this).innerHeight() - $(this).height());
						if ((slideHeight > origMinHeight) && (slideHeight > maxHeight)){
							maxHeight = slideHeight;
						}
					});

					// Reset the height of each carousel item and remove .active class
					$.each( items, function() {
						$(this)
							.css("height", "")
							// Remove .active from all slides
							.removeClass("active");
					});

					// Apply the max height to carousel
					$(".carousel", this).css("--carousel-slide-height", maxHeight + "px");

					// Mobile
				} else {
					$.each( items, function() {
						let caption 		= $('.carousel-caption', this);
						let captionHeight 	= caption.css('height', 'auto').outerHeight();

						if ((captionHeight > origMinHeight) && (captionHeight > maxHeight)){
							maxHeight = captionHeight;
						}
					});

					// Reset the height of each carousel item and remove .active class
					$.each( items, function() {
						$(this)
							.css("height", "")
							// Remove .active from all slides
							.removeClass("active");
					});
					$.each( items, function() {
						$('.carousel-caption', this).css("height", "")
					});

					// Apply the max height to carousel
					$(".carousel", this).css("--carousel-slide-height", maxHeight + "px");
				}

				// Add the active class back to the first slide
				$('.carousel-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		carouselEqualHeights();

		/**
		 * Testimonial - Set equal heights
		 */
		function testimonialEqualHeights() {
			$('.testimonial-large-block, .testimonial-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				$.each( items, function() {
					let caption 		= $('.card-body', this);
					let captionHeight 	= caption.outerHeight();

					if ( captionHeight > maxHeight ) {
						maxHeight = captionHeight;
					}
				});

				// Apply the max height to all captions
				$.each( items, function() {
					let caption = $('.card-body', this);
					caption.css( 'height', maxHeight );

					// Remove .active from all slides
					$( this ).removeClass( 'active' );
				});

				// Add the active class back to the first slide
				$('.testimonial-large-block .carousel-inner .carousel-item:first-of-type, .testimonial-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		testimonialEqualHeights();


	});

	/*let calculateNavbarHeight = function(){

		let navbarHeight = 0;

		$(":root").css("--header-navbar-height", "");

		if($("#header-search-overlay").is(":visible") && ($(window).width() >= parseInt($(":root").css("--breakpoint-lg")))){

			navbarHeight = $("#header-search-overlay").outerHeight();

		}else{

			$("body > header").children(":not(#header-search-overlay)").each(function(){

				if($(this).is(":visible")){
					navbarHeight += $(this).outerHeight();
				}

			});

		}

		$(":root").css("--header-navbar-height", navbarHeight + "px");

	};*/

	/*let calculateTopBannerHeight = function(){

		if($("body > header .header-top-banner").length > 0){

			let topBannerHeight = $("body > header .header-top-banner").outerHeight();

			$("body > header").css("--header-top-banner-height", topBannerHeight + "px");

		}

	};*/

	let fadeInMenuDropdown = function(dropdown){

		if($(window).width() >= parseInt($(":root").css("--desktop-menu-breakpoint"))){
			dropdown.removeClass("fade-out").addClass("fade-in");
		}

	};

	let fadeOutMenuDropdown = function(dropdown){

		if($(window).width() >= parseInt($(":root").css("--desktop-menu-breakpoint"))){
			dropdown.removeClass("fade-in").addClass("fade-out");
		}

	};

	// Fires event when element has scrolled up to or away from the top of it's parent
	$.fn.observeScrollTopChanges = function() {

		// Top and bottom margin values position marker element at the top of the box area of the current element, regardless of it's top margin
		// Need to increase bottom margin's negative value by 1px to compensate for marker's height
		// Essentially makes the marker invisible
		const marker = $("<div>").css({
			"margin-top":       this.css("marginTop"),
			"margin-bottom":    ((parseInt(this.css("marginTop")) + 1) * -1),
			"height":           "1px",
		});

		// Add to DOM before element being observed
		// When marker is hidden beyond the top of the viewport, the target element will be touching the top of the viewport
		this.before(marker);

		// Create observer object
		const scrollTopObserver = new IntersectionObserver((entries) => {

			// Width, height and scroll position of element being observed
			const targetBoundingRect = entries[0].boundingClientRect;
			// Width height and position of viewport
			const viewportBoundingRect = entries[0].rootBounds;

			// The element that should have the event triggered on it
			// Basically, the element that we want to know when it has reached the top of the page on scroll
			const evtTrigger = entries[0].target.nextSibling;

			let scrolledToTop = false;

			// If the entire marker element has scrolled beyond the top of the viewport
			if(targetBoundingRect.bottom < viewportBoundingRect.top){

				scrolledToTop = true;

				// If the entire marker element is visible again
			}else if(targetBoundingRect.bottom >= viewportBoundingRect.top){

				scrolledToTop = false;

			}

			// Create custom event and pass information about whether the element was just hit the top of the page or if it is being scrolled away
			const evt = new CustomEvent("scroll-top-change", {detail: {scrolledToTop: scrolledToTop}});

			evtTrigger.dispatchEvent(evt);

			// Threshold says how much of the element needs to be visible before checking for intersection
			// 0 means as soon as any part of the element is visible
		}, {threshold: [0]});

		// Start observing the marker element
		scrollTopObserver.observe(marker.get(0));

		// Return current element to allow for jQuery function chaining
		return this;

	};

})(jQuery);